import React from 'react';

// Public route imports - COPIED EXACTLY from App.tsx
const About = React.lazy(() => import('@/pages/About'));
const Blog = React.lazy(() => import('@/pages/Blog'));
const BlogPost = React.lazy(() => import('@/pages/BlogPost'));
const ContactRedirect = React.lazy(() => import('@/components/ContactRedirect').then((m) => ({ default: m.ContactRedirect })));
const PrivacyPolicy = React.lazy(() => import('@/pages/PrivacyPolicy'));
const TermsConditions = React.lazy(() => import('@/pages/TermsConditions'));
const Returns = React.lazy(() => import('@/pages/Returns'));
const Help = React.lazy(() => import('@/pages/Help'));
const UnsubscribePage = React.lazy(() => import('@/pages/UnsubscribePage'));

// Public informational routes (no authentication required)
export const publicRoutes = [
  {
    path: 'about',
    element: <About />,
  },
  {
    path: 'unsubscribe',
    element: <UnsubscribePage />,
  },
  {
    path: 'blog',
    element: <Blog />,
  },
  {
    path: 'blog/:slug',
    element: <BlogPost />,
  },
  {
    path: 'contact',
    element: <ContactRedirect />,
  },
  {
    path: 'privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: 'terms-conditions',
    element: <TermsConditions />,
  },
  {
    path: 'returns',
    element: <Returns />,
  },
  {
    path: 'help',
    element: <Help />,
  },
];